import React, { useState } from "react";
import {
  Box,
  Typography,
} from "@mui/material";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { useNavigate } from "react-router-dom";

interface UserCardProps {
  emailUsuario: string;
  tipoAgente: string;
  idAgente: string;
  nomeEmpresa: string;
  nome: string;
}

const UserCard: React.FC<UserCardProps> = ({
  tipoAgente,
  nomeEmpresa,
  nome
}) => {
  
  return (
  <>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        padding: "10px 14px",
        borderRadius: "16px",
        background: "transparent",
        minWidth: "260px"
      }}
    >
      <Box
        sx={{
          width: 42,
          height: 42,
          borderRadius: "50%",
          background: "#DBEAFE",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0
        }}
      >
        <AccountCircleOutlinedIcon
          sx={{
            color: "#2563EB",
            width: 28,
            height: 28
          }}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          overflow: "hidden"
        }}
      >

        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 700,
            color: "#0F172A",
            lineHeight: 1.2
          }}
        >
          {nome}
        </Typography>

        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 600,
            color: "#2563EB",
            lineHeight: 1.3
          }}
        >
          {tipoAgente}
        </Typography>

        <Typography
          sx={{
            fontSize: "12px",
            color: "#64748B",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}
        >
          {nomeEmpresa}
        </Typography>
      </Box>
    </Box>
  </>
);
};

export default UserCard;
